import { Box, IconButton } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

export const SideBySideComparisonList = styled(Box)`
  background-color: ${(p) => p.theme.colors.background2};
  border-radius: 0.5rem;
  margin-top: 2rem;
  padding: 0 0 1.5rem 0;
`;

export const SideBySideComparisonHeader = styled(Box)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  padding: 0 1rem;

  ${(p) => p.theme.media.tabletDown} {
    justify-content: flex-start;
  }
`;

export const NavButtonsContainer = styled(Box)`
  position: absolute;
  left: 1rem;
  display: flex;
  gap: 0.25rem;
  align-items: center;

  ${(p) => p.theme.media.tabletDown} {
    display: none;
  }
`;

export const SlideItem = styled(Box)`
  width: 220px;
  flex-shrink: 0;

  ${(p) => p.theme.media.mobileDown} {
    width: 160px;
  }
`;

export const DragOverlayCard = styled(Box)`
  width: 220px;
  border-radius: 0.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  transform: rotate(1deg);
  cursor: grabbing;
`;

export const NavButton = styled(IconButton)`
  background-color: ${(p) => p.theme.button.outlined.colors.background};
  color: ${(p) => p.theme.button.outlined.colors.text};
  border: 1px solid ${(p) => p.theme.button.outlined.colors.border};

  &:hover,
  &:focus,
  &:active {
    border: 1px solid ${(p) => p.theme.button.outlined.colors.border};
  }
`;
